import Skeleton from "react-loading-skeleton"

const CategoriesLoadingState = () => {
    return (
        <div className="grid grid-cols-1 gap-8 pb-16 lg:grid-cols-3">
            <Skeleton count={1} height={256} className="flex-1" />
            <Skeleton count={1} height={256} className="flex-1" />
            <Skeleton count={1} height={256} className="flex-1" />
            <Skeleton count={1} height={256} className="flex-1" />
            <Skeleton count={1} height={256} className="flex-1" />
            <Skeleton count={1} height={256} className="flex-1" />
        </div>
    )
}

export default CategoriesLoadingState
